import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './App';
import { UserProvider } from 'context/userContext';
import { BrowserRouter as Router } from 'react-router-dom';
import { SidebarProvider } from 'context/sidebarContext';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <UserProvider>
        <SidebarProvider>
          <App />
        </SidebarProvider>
      </UserProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
